import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletRequestDecisionReadSlice = createSlice({
  name: "BookletRequestDecisionReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletRequestDecisionRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletRequestDecisionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletRequestDecisionRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletRequestDecisionRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletRequestDecisionRead,
  failureBookletRequestDecisionRead,
  successBookletRequestDecisionRead,
  clearBookletRequestDecisionRead,
} = BookletRequestDecisionReadSlice.actions;

export default BookletRequestDecisionReadSlice.reducer;
